import type { FaireProductEntity } from "../../entity_types/product";

export const p_s5yvtd4qmv: FaireProductEntity = {
  token: "p_s5yvtd4qmv",
  type: "product",
  name: "Shell Ornaments",
  brandName: "Wings Hawaii",
  imageUrl:
    "https://cdn.faire.com/fastly/b701496beb37418d332e897631ac3467e62037f8aca90211609bc28b7f50d993.jpeg",
  priceDollars: 24.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/ffe806d04dc3e831b39df8714c37d318e748877fe6bb381060f76f4445a5fcd4.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
